import WrittenForm from '../components/Written/Form'

export default [
  {
    path: '/written-surveys',
    name: 'writtenSurveyEditStep1',
    component: WrittenForm,
    props: {
      step: 1,
    },
    meta: {
      breadcrumbs: [
        { text: 'B. 書面調査情報の入力' },
        { text: '整合性確認表の選択' },
      ],
    },
  },
  {
    path: '/written-surveys/:id/step2',
    name: 'writtenSurveyEditStep2',
    component: WrittenForm,
    props: route => ({
      step: 2,
      id: route.params.id,
    }),
    meta: {
      breadcrumbs: [
        { text: 'B. 書面調査情報の入力', to: { name: 'writtenSurveyEditStep1' }, exact: true },
        { text: '書面調査情報の入力' },
      ],
    },
  },
  {
    path: '/written-surveys/:id/step3',
    name: 'writtenSurveyEditStep3',
    component: WrittenForm,
    props: route => ({
      step: 3,
      id: route.params.id,
    }),
    meta: {
      breadcrumbs: [
        { text: 'B. 書面調査情報の入力', to: { name: 'writtenSurveyEditStep1' }, exact: true },
        { text: '書面調査情報の保存' },
      ],
    },
  },
]
